export default __webpack_public_path__ + "static/media/check.a6a2b429.svg";